import { Loader2, Sparkles } from 'lucide-react'

/**
 * La place réservée pendant que l'assistant fabrique le bloc.
 *
 * L'éditeur a cliqué « + » à un endroit précis puis a décrit ce qu'il voulait ;
 * le tour dure de quelques secondes à plusieurs minutes. Sans cette empreinte,
 * l'écran ne change pas du tout entre le clic et la réponse : rien ne dit que la
 * demande a été prise, ni où le bloc atterrira.
 *
 * Volontairement de la HAUTEUR d'un bloc, pas d'un liseré : c'est la promesse de
 * ce qui vient. Elle n'est ni cliquable ni sélectionnable — il n'y a rien à y
 * faire —, et `aria-live` l'annonce une fois aux lecteurs d'écran.
 *
 * Elle disparaît quand le tour finit, quoi qu'il ait produit : le carré signale
 * une ATTENTE, pas une réussite. Un tour qui n'a rien créé (une question, un
 * refus) doit le laisser retomber, sinon l'attente devient un mensonge
 * permanent.
 */
/**
 * `fit` — la variante des CASES : dans une grille, la place réservée a déjà une
 * taille, celle de la zone dessinée. La hauteur de bloc du cas ordinaire y
 * déborderait sur les cases voisines ; la recette `--fit` s'en remet donc à la
 * case et replie l'aide, qui n'aurait pas la place d'être lue.
 */
export const BuilderBlockSkeleton = ({ label = 'Création du bloc en cours…', fit = false }) => (
  <div
    className={`builder-block-skeleton${fit ? ' builder-block-skeleton--fit' : ''}`}
    role="status"
    aria-live="polite"
    data-testid="builder-block-skeleton"
  >
    <div className="builder-block-skeleton-body">
      <span className="builder-block-skeleton-icon">
        <Sparkles size={18} aria-hidden="true" />
        <Loader2 size={28} className="builder-block-skeleton-spin" aria-hidden="true" />
      </span>
      <p className="builder-block-skeleton-label">{label}</p>
      <p className="builder-block-skeleton-hint">
        Le bloc se placera ici. Vous pouvez en demander d'autres pendant ce temps.
      </p>
    </div>
  </div>
)
